import React, { useMemo } from 'react';

import {
  CategoryProvider,
  isUrlNamesMatch,
  TopTournamentsCategoryProvider,
  useSportsbookState,
  useSportState,
} from '@atlas/core';

import SimplifiedTournamentHeader from 'components/Pages/Prematch/SimplifiedTournamentHeader';
import { SimpleSearchList, useSimpleSearchState } from 'components/Search';
import SeoPageText from 'components/SeoPage/SeoPageText';
import SimpleFilters from 'components/SimpleFilters/SimpleFilters';

import { TopTournamentsProvider } from './SimplifiedTopTournamentsProvider';
import SimplifiedTopTournamentsViewProvider from './SimplifiedTopTournamentsViewProvider';
import SimplifiedTournamentsList from './SimplifiedTournamentsList';

const SimplifiedTournamentsView = () => {
  const { categories, id } = useSportState();
  const { selectedCategoryUrlName } = useSportsbookState();
  const { isOpened } = useSimpleSearchState();

  const category = useMemo(
    () => categories.find(category => isUrlNamesMatch(category.urlName, selectedCategoryUrlName)),
    [categories, selectedCategoryUrlName],
  );

  const renderTournamentsList = useMemo(() => {
    if (category) {
      return (
        <CategoryProvider category={category} key={category.id}>
          <SimplifiedTournamentHeader />
          <span className="sport-scroll" />
          <SimpleFilters />
          {!isOpened && <SimplifiedTournamentsList />}
        </CategoryProvider>
      );
    }

    return (
      <SimplifiedTopTournamentsViewProvider firstItemChild={<SimpleFilters />}>
        {!isOpened && <SimplifiedTournamentsList />}
      </SimplifiedTopTournamentsViewProvider>
    );
  }, [category, isOpened]);

  return (
    <TopTournamentsCategoryProvider sportId={id}>
      <TopTournamentsProvider>
        {renderTournamentsList}
        <SimpleSearchList />
        <SeoPageText />
      </TopTournamentsProvider>
    </TopTournamentsCategoryProvider>
  );
};

export default SimplifiedTournamentsView;
